import { connect } from 'react-redux';
import React from 'react';

var SpacesSettingAccountBindingForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.changeSlide = this.changeSlide.bind(this);this.updateSpace = this.updateSpace.bind(this);}getInitialState()

  {
    const { accountBindingValue } = this.props;
    return {
      accountOnly: accountBindingValue };

  }changeSlide()
  {
    let accountOnly = !this.state.accountOnly;
    this.setState({
      accountOnly });

    this.updateSpace({ device_account_binding_setting: accountOnly });
  }updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        general_settings: model }) },


    {
      key: 'general_settings' });


  }render()
  {
    const { accountOnly } = this.state;
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
        className="slide-btn"
        onClick={() => {
          this.changeSlide();
        }}>

          <span
          className={`slide-bg ${accountOnly ? 'slide-left' : 'slide-right'}`}>

            <span className="slide-move" />
          </span>
        </div>
        <span style={{ marginLeft: 10, marginBottom: 5 }}>
          限定账号只可以绑定一个手机号码
        </span>
      </div>);

  }};


function mapStateToProps(state, props) {
  const setting = (props.setting && props.setting.settings) || {};
  const { device_account_binding_setting } = setting;
  let accountBindingValue = device_account_binding_setting;
  return {
    accountBindingValue };

}
function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
SpacesSettingAccountBindingForm);
